// extracted by mini-css-extract-plugin
export default {"SocialButton":"SocialButton-module_SocialButton__Jw1uU"};